import { priceButton } from 'rp-prices-component';

import { priceHistory } from './priceHistory';

export class PriceHandlers {
    constructor() {
        priceHistory.activate();
        priceButton.activate();
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/priceHandlers.js